export const OPTIMIZELY_FLAGS = {
	FACILITY_PAGE_REDESIGN: "sdc_facility_redesign_ab_testing_26Q1",
	SEARCH_RESULTS_PAGE_AA_TEST: "sf-23421_feature_experimentation_a_a_test"
};

export const SEARCH_RESULTS_PAGE_AA_TEST_VARIATIONS = {
	VARIATION: "variation",
	CONTROL: "control"
};
